import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header/header";
import Footer from "./components/Footer/footer";
import Sidenav from "./components/LeftSideNavigation/sidenav";
import Quicklinks from "./components/RightSideWidgets/widgetquicklinks";
import WidgetLogin from "./components/RightSideWidgets/widgetlogin";
import Contact from "./components/RightSideWidgets/widgetcontact";
import Mainsetup from "./components/mainsetup";
import FileUploadInfoProvider from "./components/Contexts/fileUploadInfoProvider";
import LoginProvider from "./components/Contexts/loginProvider";
import { UserLoginData } from "./TypeScript/interfaces";
import { AxiosResponse, AxiosError } from "axios";
import api from "./axios/axios";
import ErrorPage from "./components/ErrorPage/errorPage";

function App() {
  const [env, setEnv] = useState("");
  const [warnings, setWarnings] = useState<string[]>([]);
  const [selectedPage, setSelectedPage] = useState("BolDescription");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [displayBOList, setDisplayBOList] = useState(false);
  const [userLoginData, setUserLoginData] = useState<UserLoginData>(
    {
      salutation: "",
      firstName: "",
      lastName: "",
      email: "",
      userType: "",
      customerOrg: "",
      phoneNbr: "",
    }
  );

  useEffect(() => {

    api
        .post("/bol-gui/v1/bol/getEnv")
        .then((response: AxiosResponse) => {
            setEnv(response.data);
        })
        .catch((error: AxiosError) => {
          console.log(JSON.stringify(error, null, 2));
        });

    const loginCheck = async () => {
      await api
        .post("/bol-gui/v1/bol/isLogged")
        .then((response: AxiosResponse) => {          
          if (response.data.firstName) {
            setUserLoginData({
              salutation: String(response.data.salutation || ""),
              firstName: String(response.data.firstName),
              lastName: String(response.data.lastName),
              email: String(response.data.email),
              userType: String(response.data.userType || ""),
              customerOrg: String(response.data.customerOrg || ""),
              phoneNbr: String(response.data.phoneNbr || "")
            });
            setDisplayBOList(true);
            setSelectedPage("MarketSelection");
          }
        })
        .catch((error: AxiosError) => {
          console.log(JSON.stringify(error, null, 2));
          setSelectedPage("ErrorPage");
        });
    };
    
    loginCheck();


  }, []);

  return (
    <>
    <div className="inline" style={{color: "#ff0000"}}>{env !== "prod" && env } </div>
    <div className="App">
      <LoginProvider>
        <Header />
        <FileUploadInfoProvider>
          <div className="inline">
            <Sidenav
              displayBOList={displayBOList}
              selectedPage={selectedPage}
              selectedCountry={selectedCountry}
              selectedOption={selectedOption}
              setSelectedCountry={setSelectedCountry}
              setSelectedPage={setSelectedPage}
              setSelectedOption={setSelectedOption}
              env= {env}
            />
          </div>
          <div className="inline">
            <Mainsetup
              setSelectedPage={setSelectedPage}
              selectedPage={selectedPage}
              setSelectedCountry={setSelectedCountry}
              country={selectedCountry}
              setSelectedOption={setSelectedOption}
              selectedOption={selectedOption}
              setDisplayBOList={setDisplayBOList}
              userLoginData={userLoginData}
              setUserLoginData={setUserLoginData}
              warnings={warnings}
              setWarnings={setWarnings}
            />
          </div>
          <div className="inline">
            <aside className="grid-2">
              <Quicklinks />
              <WidgetLogin
                setSelectedPage={setSelectedPage}
                setDisplayBOList={setDisplayBOList}
                setUserLoginData={setUserLoginData}
                userLoginData={userLoginData}
              />
              <Contact />
            </aside>
          </div>
          <br className="clearBoth" />
        </FileUploadInfoProvider>
        <Footer />
      </LoginProvider>
    </div>
    </>
  );
}

export default App;
